import React, { useEffect } from 'react'
import { Box, styled } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { isDev, useDeepCompareEffect, useRequest } from 'storfox-api-hooks'
import { path } from 'ramda'
import { generatePath, useNavigate } from 'react-router-dom'

import AppContainer from '~/components/AppContainer'
import Logo from '~/components/Logo'
import * as API from '~/constants/api'
import * as ROUTES from '~/constants/routes'
import { useToken } from '~/components/Token'
import { OVERVIEW_TABS } from '~/constants/tabs'

import Delivery from '../components/Images/delivery.svg'
import WarehouseImage from '../components/Images/warehouse-image.png'

const BoxContainer = styled(Box)(({ theme }) => ({
  width: '70vw',
  height: '100vh',
  zIndex: 10,
  background: '#FFFFFF',
  [theme.breakpoints.down('sm')]: {
    width: '100vw',
  }
}))

const BoxImageContainer = styled(Box)(({ theme }) => ({
  width: '30vw',
  height: '100vh',
  zIndex: 9,
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    display: 'none'
  }
}))

const ImageTopBox = styled(Box)({
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  zIndex: 8,
  width: '100%',
  height: '100vh'
})

const ImageTopText = styled(Typography)(({ theme }) => ({
  marginBottom: '24px',
  width: '15vw',
  textAlign: 'center',
  [theme.breakpoints.down('lg')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px'
  }
}))

const ImageGradientBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  zIndex: 7
})

const GradientBox = styled(Box)({
  width: '100%',
  height: '100vh',
  background: 'rgba(54, 54, 54, 0.95)',
  zIndex: 6
})

const LogoStyled = styled(Logo)({
  width: 160,
  height: 60
})

const LogoBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  padding: '7px',
  display: 'flex',
  justifyContent: 'space-between',
  width: '70vw',
  alignItems: 'center',
  background: '#415C98',
  height: '50.5px',
  [theme.breakpoints.down('sm')]: {
    width: '100vw',
  }
}))

const DeliveryStyled = styled(Delivery)({
  width: '25vw'
})

function SignUpContainer () {
  const { t } = useTranslation()
  const { token } = useToken()
  const navigate = useNavigate()
  const request = useRequest()

  useDeepCompareEffect(() => {
    if (token) {
      const redirectTo = generatePath(ROUTES.OVERVIEW_PATH, { tab: OVERVIEW_TABS.FULFILLMENT })
      navigate(redirectTo)
    }
  }, [token])

  useEffect(() => {
    if (!token) {
      request.post(API.AGGRAK_AUTH, { redirectUri: isDev ? "https://app-dev.storfox.com/oauth2/aggrakid/callback/" : "https://wms.aggrak.io/oauth2/aggrakid/callback/" }).then((res) => {
        const url = path(['data', 'url'], res)
        window.open(url, '_self')
      })
    }
  }, [token, request])

  return (
    <AppContainer title="Sign Up">
      <Box sx={{ display: 'flex' }}>
        <BoxContainer>
          <LogoBox>
            <LogoStyled />
          </LogoBox>
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '24px'
            }}
          >
            <div className="loader" />
          </Box>
        </BoxContainer>
        <BoxImageContainer>
          <ImageTopBox>
            <ImageTopText color="white" variant="h2">{t('Delivered Happiness, Every Step of the Way')}</ImageTopText>
            <DeliveryStyled />
          </ImageTopBox>
          <ImageGradientBox>
            <GradientBox />
            <img
              src={WarehouseImage}
              alt="sign-in-image"
              style={{ height: '100vh', position: 'absolute', zIndex: 5, width: '30vw', objectFit: 'cover' }}
            />
          </ImageGradientBox>
        </BoxImageContainer>
      </Box>
    </AppContainer>
  )
}

export default SignUpContainer
